export default {applet: null, isDemoMode: true, connector: {settings: {}}};
